import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import Loader from "@componentsShared/Loader/Loader";
import OrderPaidMessage from "@/pages/checkout/CheckoutV2/components/OrderPaidMessage/OrderPaidMessage";
import ReservedMessage from "@/pages/checkout/CheckoutV2/components/ReservedMessage/ReservedMessage";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import { Icon } from "@syarahtech/ui";
import { OrderPaidError, PostReservedError } from "@/apis/orders/orders";
import { useAmwalFinance } from "@/common/Contexts/AmwalFinanceContext";
import { useTranslation } from "@i18n";

/** Compact mobile header for the amwal flow (Figma 192-43215 / 192-40009), matching
 * the split-payment mobile header: light page-blue band, centered bold title,
 * back chevron on the leading edge and a cancel action on the trailing edge.
 * Both the back button and the title hide during the OTP step (chevron because
 * the sheet has its own dismiss, title collapses to a balancing spacer). */
function AmwalMobileHeader(_ref) {
  var title = _ref.title,
    hideBack = _ref.hideBack,
    isOtpStep = _ref.isOtpStep,
    onCancel = _ref.onCancel,
    onBack = _ref.onBack;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-[#F4F7FB] px-[5%] pb-2 pt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex w-full items-center justify-between"
  }, !hideBack ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "back",
    className: "border-none bg-transparent",
    onClick: onBack
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--chevron-right-rounded",
    className: "en:rotate-180 text-primary-new",
    width: 7,
    height: 7
  })) : /*#__PURE__*/React.createElement("span", {
    className: "w-6"
  }), !isOtpStep ? /*#__PURE__*/React.createElement("strong", {
    className: "text-base font-bold leading-6 text-[#00143c]"
  }, title) : /*#__PURE__*/React.createElement("span", {
    className: "h-4 w-8"
  }), /*#__PURE__*/React.createElement("div", null)));
}
var AmwalFormLayout = function AmwalFormLayout(_ref2) {
  var checkoutOrder = _ref2.checkoutOrder,
    fetch_loading = _ref2.fetch_loading,
    fetch_error = _ref2.fetch_error,
    orderData = _ref2.orderData,
    isOtpStep = _ref2.isOtpStep,
    showCancelPopup = _ref2.showCancelPopup,
    children = _ref2.children,
    onShowCancelPopup = _ref2.onShowCancelPopup,
    onCancelPopupClose = _ref2.onCancelPopupClose,
    onCancelPopupConfirm = _ref2.onCancelPopupConfirm,
    onCancelPopupCancel = _ref2.onCancelPopupCancel;
  var isMobile = useIsMobile();
  var _useTranslation2 = useTranslation(),
    tShort = _useTranslation2.tShort;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var post_id = useAmwalFinance().queryParams.post_id;

  // Handle loading state
  if (fetch_loading) {
    return /*#__PURE__*/React.createElement(Layout, {
      hideHeaderOnmobile: true,
      disableLoader: true,
      hideFooterWithoutAuthMsg: true,
      authenticationMsg: true,
      hideAppBanner: true,
      linksForSearch: true,
      mainClass: "AribFinancePage",
      headHideLinks: true,
      hideOrangeHeadBtn: true
    }, /*#__PURE__*/React.createElement(Loader, null));
  }

  // Handle error states - check for OrderPaidError and PostReservedError
  if (fetch_error) {
    if (fetch_error instanceof OrderPaidError) {
      return /*#__PURE__*/React.createElement(Layout, {
        hideHeaderOnmobile: true,
        disableLoader: true,
        hideFooterWithoutAuthMsg: true,
        authenticationMsg: true,
        hideAppBanner: true,
        linksForSearch: true,
        mainClass: "AribFinancePage",
        headHideLinks: true,
        hideOrangeHeadBtn: true
      }, /*#__PURE__*/React.createElement(OrderPaidMessage, {
        order_id: (orderData === null || orderData === void 0 ? void 0 : orderData.order_id) || ""
      }));
    } else if (fetch_error instanceof PostReservedError) {
      return /*#__PURE__*/React.createElement(Layout, {
        hideHeaderOnmobile: true,
        disableLoader: true,
        hideFooterWithoutAuthMsg: true,
        authenticationMsg: true,
        hideAppBanner: true,
        linksForSearch: true,
        mainClass: "AmwalFinancePage",
        headHideLinks: true,
        hideOrangeHeadBtn: true
      }, /*#__PURE__*/React.createElement(ReservedMessage, null));
    }
  }
  return /*#__PURE__*/React.createElement(Layout, {
    hideHeaderOnmobile: true,
    custommobileHeader: isMobile && /*#__PURE__*/React.createElement(AmwalMobileHeader, {
      hideBack: isOtpStep,
      onCancel: onShowCancelPopup || function () {},
      onBack: function onBack() {
        return navigateTo(post_id ? "/pre-checkout/".concat(post_id) : "/pre-checkout");
      },
      title: "\u0642\u0633\u0637\u0647\u0627 \u0645\u0639 \u0623\u0645\u0648\u0627\u0644 ",
      isOtpStep: isOtpStep
    }),
    disableLoader: true,
    hideFooterWithoutAuthMsg: true,
    authenticationMsg: true,
    hideAppBanner: true,
    linksForSearch: true,
    mainClass: "AmwalFinancePage",
    headHideLinks: true,
    hideOrangeHeadBtn: true
  }, children);
};
export default AmwalFormLayout;